import { createAction, props } from '@ngrx/store';
import { IPendingInvitedEmployeesQuickSearchQueryRequest, ISendInviteRequest } from '../../../shared/models/shared.model';

export const loadResendInvites = createAction(
  '[ResendInvite] Load ResendInvites',
  props<{
    businessId: string;
    businessInviteIdList: ISendInviteRequest;
    pendingInvitesModel: IPendingInvitedEmployeesQuickSearchQueryRequest;
    groupUserRoleIds: string[];
  }>()
);

export const loadResendInvitesSuccess = createAction('[ResendInvite] Load ResendInvites Success', props<{ response: string }>());

export const loadResendInvitesFailure = createAction('[ResendInvite] Load ResendInvites Failure', props<{ error: Error | any }>());
